// Single source of truth for the product version surfaced in the Ask UI.
// The footer lineage line AND the header/login subtitle both derive from this —
// there is no second hardcoded copy of the version string (F3).
export const APP_VERSION = '4.0';

// Small muted subtitle shown under the "Doyle Vault" wordmark (header + sign-in).
export const POWERED_BY = `powered by DevGPT · v${APP_VERSION}`;

// Full lineage line used in footers / About.
export const LINEAGE_FOOTER = `Doyle Vault · ${POWERED_BY}`;
